/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchAuditUserResponse } from './search-audit-user-response';
import { EquipmentAuditFieldChangeResponse } from './equipment-audit-field-change-response';


export interface EquipmentAuditResponse { 
    id?: string;
    userId?: string;
    entityId?: string;
    entityType?: string | null;
    entitySnapshot?: string | null;
    entityChangedDate?: string;
    action?: string | null;
    source?: string | null;
    createdDate?: string;
    user?: SearchAuditUserResponse;
    children?: Array<EquipmentAuditResponse> | null;
    fieldChanges?: Array<EquipmentAuditFieldChangeResponse> | null;
}

